import { Injectable } from '@angular/core';
import { DataBagService } from '@/common/data-bag.service';
import { HttpClient } from '@angular/common/http';
import { Transport, TransportKind, TransportSide, TransportTerm } from '@/new-transport/_models/transport.model';
import { TransportTimetable } from '@/new-transport/_models/transport-timetable.model';
import { TransportLogic } from '@/new-transport/transport-map/transport-map.api.service';
import { TransportStops } from '@/stops/stop.models';

@Injectable({ providedIn: 'root' })
export class BagTransportTermApi {
	constructor(
		private readonly bag: DataBagService,
		private readonly httpClient: HttpClient,
	) {}

	fetchTemplates(): Promise<Transport[]> {
		return new Promise((resolve, reject) => {
			this.bag.get(`/transport/?kind=${TransportKind.TEMPLATE}`, (result, error) => {
				if (result) resolve(result.results);
				else reject(error);
			});
		});
	}

	searchTemplates(templateName: string): Promise<Transport[]> {
		return new Promise((resolve, reject) => {
			this.bag.get(
				`/transport/?kind=${TransportKind.TEMPLATE}&name__icontains=${templateName}`,
				(result, error) => {
					if (result) resolve(result.results);
					else reject(error);
				},
			);
		});
	}

	async fetchTimetablesFromTransport(transportID: number): Promise<TransportTimetable[]> {
		return new Promise((resolve, reject) => {
			this.bag.get(`/transport/timetable/?limit=9999&transport=${transportID}`, (result, error) => {
				if (result) resolve(result.results);
				else reject(error);
			});
		});
	}

	async createNewTransport(terms: TransportTerm[], side: TransportSide): Promise<Transport> {
		const term: TransportTerm = terms[0];
		const payload = {
			departureTerms: side === TransportSide.DEPARTURE ? [term.id] : [],
			returnTerms: side === TransportSide.RETURN ? [term.id] : [],
			kind: TransportKind.OFFER,
			name: term.name,
			side: side,
		};
		return new Promise((resolve, reject) => {
			this.bag.post('/transport/', payload, (result: Transport, error: Error) => {
				if (result) resolve(result);
				else {
					reject(new Error(`Couldn't create new transport: ${error}`));
				}
			});
		});
	}

	createResource(apiUrl: string, payload: any): Promise<void> {
		return new Promise((resolve, reject) => {
			this.bag.post(apiUrl, payload, (_, error) => {
				if (!error) resolve();
				else reject();
			});
		});
	}

	async fetchLogicsFromTransport(transportID: number): Promise<TransportLogic[]> {
		return new Promise((resolve, reject) => {
			this.bag.get(`/transport/transport_logic/?limit=9999&transport=${transportID}`, (result, error) => {
				if (result) resolve(result.results);
				else reject(error);
			});
		});
	}

	async getBaseTransports(id: number): Promise<Transport[]> {
		return new Promise((resolve, reject) => {
			this.bag.get(`/transport/?linked_transport=${id}`, (result, error) => {
				if (result) resolve(result.results);
				reject(error);
			});
		});
	}

	async getTemplateDestinations(): Promise<TransportStops[]> {
		return new Promise((resolve, reject) => {
			this.bag.get(`/transport/stop/?stop_type=${TransportKind.TEMPLATE}`, (result, error) => {
				if (result) resolve(result.results);
				else reject(error);
			});
		});
	}
}
